<template>
  <div class="container">
    <div style="display: flex;aligncompName-items: center;margin-top: 20px;">
      <div>关联平台企业：</div>
      <vxe-pulldown ref="sellerDown" transfer class="pulldown" style="min-width: 100px;">
        <template>
          <a :title="compName" class="link-text" @click="focusEvent" target="_black"
             style="cursor: pointer;display: inline-block;width: 100%;text-align: center;"
          >{{ compName === null || compName === "" ? placeholder : compName }}</a
          >
        </template>
        <template v-slot:dropdown>
          <div class="chainId-dropdown">
            <Input search suffix="ios-search" v-model="name" placeholder @on-search="search" style="width: 200px"/>
            <vxe-grid
                border="none"
                highlight-hover-row
                auto-resize
                height="auto"
                :loading="loading"
                :pager-config="tablePage"
                :data="tableData"
                :columns="tableColumn"
                @cell-click="cellClickEvent"
                @page-change="pageChange"
            ></vxe-grid>
          </div>
        </template>
      </vxe-pulldown>
    </div>
    <div class="add-btn-box" style="margin-top: auto;">
      <Button style="border-radius: 5px;" @click="close">取消</Button>
      <Button type="primary" style="border-radius: 5px;" @click="commit">确定</Button>
    </div>
  </div>
</template>
<script>

  import {isEmpty, isNotEmpty} from "@/utils/util";
  import $api from "@/apiProvider";

  export default {
    props: {
      placeholder: {
        type: String,
        default: "请选择平台企业",
      },
    },
    data() {
      return {
        salesMan: null,
        compName: null,
        tableData: [],
        loading: false,
        name: "",
        tableColumn: [{field: "name", title: "企业名称"}], // 表格数据列
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          size: "mini",
        },
      }
    },
    methods: {
      init(row) {
        this.userId = row.id;
        this.compName = null;
        this.compId = null;
      },
      commit() {
        if (isEmpty(this.compName)) {
          this.$XModal.alert({
            message: '请选择平台企业',
            status: "error",
          });
          return
        }
        this.addBaseUserSignAboutCompany();
      },
      async addBaseUserSignAboutCompany() {
        let res = await $api.baseUserSign.post("addBaseUserSignAboutCompany", {
          id: this.userId,
          aboutCompId: this.compId,
        });
        if (res.status == 1) {
          this.$XModal.message({message: `关联成功！`});
          this.$emit('afterSave')
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      close() {
        this.$emit('close');
      },
      focusEvent() {
        this.tablePage.currentPage = 1;
        this.userName = "";
        this.getCompanyList();
        this.$refs.sellerDown.showPanel();
      },
      search() {
        this.tablePage.currentPage = 1;
        this.getCompanyList();
      },
      cellClickEvent({row}) {
        this.compName = row.name;
        this.compId = row.id;
        if (isNotEmpty(this.$refs.sellerDown)) {
          this.$refs.sellerDown.hidePanel();
        }
      },
      pageChange(e) {
        this.tablePage.currentPage = e.currentPage;
        this.tablePage.pageSize = e.pageSize;
        this.getCompanyList();
      },
      async getCompanyList() {
        let params = {
          orderBy: 2,
          page: this.tablePage.currentPage,
          rows: this.tablePage.pageSize,
        };
        if (!isEmpty(this.name)) {
          params.name = this.name;
        }
        if (isEmpty(this.tableData)) {
          this.loading = true;
        }
        let res = await $api.department.get("listCompany", params);
        this.loading = false;
        if (res.status === 1) {
          this.tableData = res.data.rows;
          this.tablePage.total = res.data.total;
        }
      },
    }
  }
</script>
<style lang="css">
  .chainId-dropdown {
    width: 400px;
    height: 300px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
    position: relative;
  }

  .chainId-dropdown .ivu-input-wrapper {
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 999;
  }

  .chainId-dropdown .ivu-input {
    border-radius: 0;
  }

  .pulldown .vxe-pulldown--content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>